/* eslint-disable new-cap */
import { INTERCOM_ID_MERCAT } from '~constants/environment';
import LocalStorage from '~services/LocalStorageService';

export const startIntercom = () => {
  const tokenManager = LocalStorage.getTokenManager();
  if (INTERCOM_ID_MERCAT && window.Intercom) {
    window.Intercom('boot', {
      app_id: INTERCOM_ID_MERCAT,
      custom_launcher_selector: '.intercomTriggerShow',
      website: window.location.href,
      email: tokenManager?.email,
      name: tokenManager?.displayName
    });
  }
};

export const shutdownIntercom = () => {
  if (INTERCOM_ID_MERCAT) {
    window.Intercom('shutdown');
  }
};

export const onUnreadCountChange = (handler) => {
  if (INTERCOM_ID_MERCAT) {
    window.Intercom('onUnreadCountChange', handler);
  }
};
